import { cn } from "@/lib/utils";
import { PlaylistItemDTO } from "../../lib/types";
import * as Sentry from "@sentry/react";

type Props = {
  item: PlaylistItemDTO;
  isFullScreen?: boolean;
};

export const DSPlayerImage: React.FC<Props> = ({ item, isFullScreen }) => {
  return (
    <img
      className={cn("ds-player-img object-contain w-full h-full", isFullScreen && "with-full-screen")}
      id={item.id.toString()}
      src={item.src}
      onError={(event) => {
        Sentry.captureException(new Error(`[DS] Image load error for ${item.src}`), {
          tags: {
            component: "DSPlayerImage",
            imageSrc: item.src,
            imageId: item.id.toString(),
          },
          extra: {
            event,
            item,
          },
        });
      }}
    />
  );
};
